<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="text-h5">Cambiar Contraseña {{ item.email }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field label="Password *"
                                          required v-model="password"
                                          :rules="passwordRules"
                                          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'"
                                          @click:append="show1 = !show1"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field label="Confirmar Password *"
                                          required
                                          v-model="password2"
                                          :rules="passwordConfirmationRule"
                                          :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'" :type="show2 ? 'text' : 'password'"
                                          @click:append="show2 = !show2" @keydown.enter="submit"
                            ></v-text-field>
                        </v-col>
                        <v-card-text class="custom-card">
                            {{ errorMessage }}
                        </v-card-text>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="close">
                        Cerrar
                    </v-btn>
                    <v-btn color="primary" text @click="save">
                        Cambiar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
export default {
    name: 'BaseFormModal',
    emits: ['onFormValue', 'onCloseModal'],
    data: () => ({
        password: '',
        password2: '',
        show1: false,
        show2: false,
        passwordRules: [
            v => !!v || "Contraseña es requerida",
            v => (v && v.length <= 20) || "La contraseña no debe tener más de 20 caracteres"
        ]
    }),
    props:{
        errorMessage: String,
        item: Object,
        dialog: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        setError(message) {
            this.hasError = true;
            this.dialog = true;
            this.errorMessage += message+ " ";
            this.persistError = true;
        },
        setPersistError(error) {
            this.persistError = error
        },
        close() {
            this.$emit('onCloseModal', false);
        },
        save() {
            this.$emit('onFormValue', { password: this.password, password2: this.password2 })
        }

    },
    computed: {
        passwordConfirmationRule() {
            return [() => (this.password === this.password2) || "Las contraseñas no coinciden"]
        },
    }

}
</script>

<style lang="scss" scoped>
    .custom-card {
        background-color: #ffffff; /* Cambia esto al color de fondo que desees */
        color: #FF0000; /* Cambia esto al color de texto que desees */
    }
</style>
